module.exports = __webpack_public_path__ + "img/sms.e5b17c49.svg";